import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface Params extends Pick<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'className' | 'name'> {
  maxSymbols: number,
  initialValue?: string
}

function Textarea({ maxSymbols, initialValue, ...textareaParams }: Params) {
  const [value, setValue] = useState<string>(initialValue || '')
  const count = value.length;
  const over = count > maxSymbols;

  return <div>
    <textarea
      className={clsx(textareaParams.className, styles.textarea, over && styles.over)}
      name={textareaParams.name}
      onChange={(e) => setValue(e.target.value)}
      value={value}
    />
    <div className={clsx(styles.counter, over && styles.counterOver)} aria-hidden>{count}/{maxSymbols}</div>
  </div>
}


export default function TextareaPortal() {
  const [textareaElements, setTextareaElements] = useState<Element[]>([])

  useEffect(() => {
    setTextareaElements(Array.from(document.querySelectorAll('.custom_textarea')))
  }, [])

  return (<>
    {textareaElements.map(element => createPortal(<Textarea
      className={element.getAttribute('class') || undefined}
      maxSymbols={parseInt(element.getAttribute('data-max-symbols') || '500', 10)}
      name={element.getAttribute('name') || undefined}
      initialValue={element.getAttribute('data-initialValue') || undefined}
    />, element))}
  </>)
}
